import { useIntl } from "react-intl";

import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type ShareListWarningModalProps = Pick<
  YesNoModalProps,
  "isOpen" | "onClickYes" | "onClickNo"
>;

export function ShareListWarningModal({
  onClickYes,
  onClickNo,
  isOpen,
}: ShareListWarningModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen={isOpen}
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.share-list-warning-modal.title",
      })}
      body={intl.formatMessage({
        id: "components.shared-list-warning-modal.body",
      })}
      yesLabel={intl.formatMessage({
        id: "generic.actions.leave",
      })}
      noLabel={intl.formatMessage({
        id: "generic.actions.cancel",
      })}
      isGrey
    />
  );
}
